import React, { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { IndianRupee, RefreshCcw } from "lucide-react";

export default function CostCard({ startIso, endIso }) {
  const [tariff, setTariff] = useState(8.5);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchCost = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/energy/cost`, {
        params: { start: startIso, end: endIso, tariff },
      });
      setData(res.data);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchCost(); /* eslint-disable-next-line */ }, [startIso, endIso]);

  return (
    <section className="panel p-5 flex flex-col" data-testid="cost-card">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-base tracking-tight">COST ESTIMATE</h3>
        <IndianRupee className="w-4 h-4 text-zinc-500" strokeWidth={1.5} />
      </div>

      <div className="flex items-baseline gap-2 mb-4">
        <span className="font-mono-tech text-4xl">
          ₹{data ? Number(data.cost).toLocaleString("en-IN", { maximumFractionDigits: 2 }) : "—"}
        </span>
        <span className="label-tech">{data?.currency || "INR"}</span>
      </div>

      <div className="grid grid-cols-2 gap-3 text-xs font-mono-tech mb-4">
        <div>
          <div className="label-tech">kWh CONSUMED</div>
          <div className="text-white mt-0.5">{data ? Number(data.kwh_consumed).toFixed(2) : "—"}</div>
        </div>
        <div>
          <div className="label-tech">TARIFF</div>
          <div className="text-white mt-0.5">₹ {data ? Number(data.tariff).toFixed(2) : "—"} / kWh</div>
        </div>
      </div>

      <div className="mt-auto flex items-center gap-2">
        <Input
          data-testid="tariff-input"
          type="number"
          step="0.1"
          value={tariff}
          onChange={(e) => setTariff(parseFloat(e.target.value || "0"))}
          className="bg-white/5 backdrop-blur-md border-white/15 rounded-sm font-mono-tech h-9"
        />
        <Button
          data-testid="recalc-cost-btn"
          onClick={fetchCost}
          disabled={loading}
          className="bg-white text-black hover:bg-zinc-200 rounded-sm h-9"
        >
          <RefreshCcw className="w-3 h-3 mr-2" /> RECALC
        </Button>
      </div>
    </section>
  );
}
